// extracted by mini-css-extract-plugin
export default {"toggleWrap":"toggle_toggleWrap__D1Es9","first":"toggle_first__MItTf","switch":"toggle_switch__4G2xi","second":"toggle_second__YFzXK"};